export default __webpack_public_path__ + "static/appStore-390e94815f5b7760343aaf589262c427.png";